import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as templateActions from 'modules/templateAttach';

import { ExamAttachDelete } from 'components';

class CtExamAttachDelete extends Component {
  constructor(props) {
    super(props);

    this.state = {
      deleting: false
    };
  }

  removeTemplate = async () => {
    this.setState({ deleting: true });

    const { mountDeleteModal, templateInfo: { attachInfoNo } } = this.props;

    const params = {};
    let isOk = true;
    if (attachInfoNo) {
      params.attachInfoNo = attachInfoNo;
    } else {
      // 오류
      isOk = false;
    }

    if (isOk) {
      try {
        const { TemplateActions } = this.props;
        await TemplateActions.deleteAttach(params);
      } catch (e) {
        console.log(e);
      }
    } else {
      console.log('removeTemplate isOk fail!');
    }
  };

  render() {
    const { deleting } = this.state;
    const { templateInfo, mountDeleteModal } = this.props;
    const { removeTemplate } = this;

    return (
      <ExamAttachDelete
        deleting={deleting}
        templateInfo={templateInfo}
        removeTemplate={removeTemplate}
        handleOnToggleDeleteModal={mountDeleteModal}
      />
    );
  }
}

CtExamAttachDelete.propTypes = {};
CtExamAttachDelete.defaultProps = {};

const mapDispatchToProps = dispatch => ({
  TemplateActions: bindActionCreators(templateActions, dispatch)
});

export default connect(undefined, mapDispatchToProps)(CtExamAttachDelete);



// WEBPACK FOOTER //
// ./src/script/containers/examAttach/CtExamAttachDelete.js